<template>
  <v-dialog v-model="dialog" @input="close" width="600">
    <v-card>
      <v-card-title class="title">Invalidar Imagem</v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            outlined
            dense
            label="Número do auto invalidado"
            v-model="dados.numero_auto_invalidado"
            :rules="requiredRules"
            required
            @input="dados.numero_auto_invalidado = dados.numero_auto_invalidado.toUpperCase()"
          />

          <v-text-field
            outlined
            dense
            label="Número do auto substituto"
            v-model="dados.numero_auto_novo"
            :rules="requiredRules"
            required
            @input="dados.numero_auto_novo = dados.numero_auto_novo.toUpperCase()"
          />

          <v-textarea
            outlined
            dense
            label="Justificativa"
            v-model="dados.justificativa"
            :rules="requiredRules"
            required
          />
        </v-form>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="primary" outlined @click="close">Fechar</v-btn>
        <v-btn @click="save(dados)" color="primary">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "ModalInvalidarImagemAutoManual",
  data() {
    return {
      dados: {},
      valid: true,
      dialog: false,
      requiredRules: [(v) => !!v || "Este Campo é Obrigatório"],
    };
  },
  methods: {
    open() {
      return new Promise((resolve, reject) => {
        this.dialog = true;
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    close() {
      this.$refs.form.reset();
      this.dialog = false;
      // this.reject();
      // this.close();
    },

    async save(payload) {
      if (!this.$refs.form.validate()) return;
      this.resolve({ ...payload });
      this.close();
    },
  },
};
</script>
